<template>
	<div class="popup popup--mini" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">Уверены, что желаете удалить предложение?</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__content">
				<div class="popup__btns">
					<button class="btn btn--color" @click.prevent="sendForm">Да</button>
					<button class="btn btn--border" @click="$emit('close')">Нет</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Fetch from "@/utils/Fetch";
import {useToast} from "vue-toastification";


export default {
	name: 'ApproveRemoveOfferPopup',
	props: {
		selectedOffer: {
			type: Number,
			default: () => null
		}
	},
	data() {
		return {
			toast: useToast(),
		}
	},
	methods: {
		async sendForm() {
			let response = await Fetch(`tenders/offers/remove/${this.selectedOffer}/`, {
				method: 'POST',
			})

			if(response.success) {
				this.toast.success(`Предложение успешно удалено`);
				this.$emit('refreshTenderOffers')
				this.$emit('close')
			} else {
				this.toast.error(response.message);
				this.$emit('close')
			}
		}
	},

}
</script>
